var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardCareplan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 24.5C15.155 24.5 17.5 22.155 17.5 19.25C17.5 16.345 15.155 14 12.25 14C9.345 14 7 16.345 7 19.25C7 22.155 9.345 24.5 12.25 24.5ZM12.25 17.5C13.2125 17.5 14 18.2875 14 19.25C14 20.2125 13.2125 21 12.25 21C11.2875 21 10.5 20.2125 10.5 19.25C10.5 18.2875 11.2875 17.5 12.25 17.5ZM33.25 12.25H19.25V26.25H5.25V12.25H1.75V29.75H40.25V19.25C40.25 15.3825 37.1175 12.25 33.25 12.25ZM36.75 26.25H22.75V15.75H33.25C35.175 15.75 36.75 17.325 36.75 19.25V26.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardCareplan);
export default __webpack_public_path__ + "static/media/DashboardCareplan.ae3654759e0cef9a2482da339f535fb3.svg";
export { ForwardRef as ReactComponent };